<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  /* height: 120px; */
  border-radius: 10px;
}
.card-read-only {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  height: auto;
  border-radius: 10px;
  display: flex;
}
.card-payment {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  height: auto;
  border-radius: 10px;
  padding:30px 20px;
}
.card-flex {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
}

.card-active {
    border: 1px solid #fbda0c;
    background:#fbda0c;
    /* background: transparent; */
}

.card-flex:hover {
  box-shadow: 0 8px 16px 0 #fbda0c;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.d-none-width {
    width: 250px; 
    max-width: 250px; 
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.d-none-price {
    width: 100px;
}

.deliver{
    border:solid 1px #e3e3e3;
    border-radius:10px;
    display: flex;
    padding: 20px;
    align-items: center;
    margin: 10px 40px 10px 10px;
}

@media only screen and (max-width: 600px) {
  .d-none-width {
    width: auto;
    max-width: 100%;
  }
  .d-none-price {
      width: auto;
  }
  .mobile-product {
      padding: 20px;
  }
}
</style>
<template>
    <div>
        <main id="content" role="main" class="cart-page" v-loading.fullscreen.lock="fullscreenLoading">
            <div class="container">
                <div class="row my-8">
                    <div class="col-2 col-md-3"></div>
                    <div class="col-8 col-md-6">
                        <div class="order-progress"> 
                            <div>
                                <div class="order-progress-first-circe order-progress-active"> 
                                    <img v-if="step==0" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div >Сагслах</div>
                                </div> 
                                <div class="order-progress-middle-line " :class="{'order-progress-active':step>=1}"></div> 
                                <div class="order-progress-second-circle " :class="{'order-progress-active':step>=1}">
                                    <img v-if="step==1" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div >Хаягын мэдээлэл оруулах</div>
                                </div>
                            </div>
                            <div >
                                <div class="order-progress-middle-line" :class="{'order-progress-active':step>=2}"></div> 
                                <div class="order-progress-third-circle" :class="{'order-progress-active':step>=2}">
                                    <img v-if="step==2" src="@/assets/svg/checkmark.svg" class="check-svg">
                                    <div>Төлбөр төлөх</div>
                                </div>
                            </div>
                            </div>
                    </div>
                    <div class="col-2  col-md-3"></div>
                </div>
                <span style="float: right;margin-right: 20px;font-size: 16px;">Миний бонус <i class="fas fa-gift" style="font-size: 14px;margin:0 2px 0px 10px;marg"></i>{{checkBonus()}}</span>
                <div style="clear: both;"></div>
            </div>

            <div class="container">
                    <div class="row">
                        <div class="mb-2 cart-table col-md-8">
                            <div class="row">
                                 <div class="col-md-12 p-1"> 
                                    <div class="card-payment"> 
                                        <b style="margin: 10px;font-size: 1.2rem;">Төлбөр төлөх</b>
                                        <div class="row" style="width: 100%;">
                                            <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('golomt')">
                                                    <input type="radio" v-model="payment" value="golomt" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/payment/golomtpay.png" style="width: 20px;height: auto; margin-right: 10px;">
                                                    <span>Голомт банк</span>
                                                </div>
                                           </div>
                                           <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('qpay')">
                                                    <input type="radio" v-model="payment" value="qpay" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/logo/qpay.jpeg" style="width: 20px;height: auto; margin-right: 10px;">
                                                    <span>Qpay</span>
                                                </div>
                                           </div>
                                           <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('monpay')">
                                                    <input type="radio" v-model="payment" value="monpay" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/payment/monpay.png" style="width: 20px;height: auto; margin-right: 10px;">
                                                    <span>Monpay</span>
                                                </div>
                                           </div>
                                           <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('mobile')">
                                                    <input type="radio" v-model="payment" value="mobile" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/payment/cashpay.png" style="width: 40px;height: auto; margin-right: 10px;">
                                                    <span>Дансаар шилжүүлэх</span>
                                                </div>
                                           </div>
                                        </div>
                                        <b style="margin: 10px;font-size: 1.2rem;">Зээлээр авах</b>
                                        <div class="row" style="width: 100%;">
                                            <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('KhanLending')">
                                                    <input type="radio" v-model="payment" value="KhanLending" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/logo/khanbank.png" style="width: 20px;height: auto; margin-right: 10px;">
                                                    <span>Хаан банк</span>
                                                </div>
                                           </div>
                                           <!-- <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('storepay')">
                                                    <input type="radio" v-model="payment" value="storepay" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/logo/storepay.png" style="width: 25px;height: auto; margin-right: 10px;">
                                                    <span>Storepay</span>
                                                </div>
                                           </div> -->
                                           <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('pocket')">
                                                    <input type="radio" v-model="payment" value="pocket" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/logo/pocket.png" style="width: 20px;height: auto; margin-right: 10px;">
                                                    <span>Pocket</span>
                                                </div>
                                           </div>
                                           <div class="col-12 col-md-6">
                                                <div style="display: flex;padding: 10px;margin:10px ; border:solid 1px #e3e3e3;border-radius:25px;padding-left:20px;cursor: pointer" @click="changePayment('mcredit')">
                                                    <input type="radio" v-model="payment" value="mcredit" style="margin-right: 10px;"> 
                                                    <img src="@/assets/images/logo/mcredit.png" style="width: 25px;height: auto; margin-right: 10px;">
                                                    <span>Mcredit</span>
                                                </div>
                                           </div>
                                        </div>
                                        <b style="margin: 15px 10px 5px 10px; font-size: 1.2rem;display: block">Санамж</b>
                                        <div class="row"> 
                                               <div class="col-12">
                                                  <div class="deliver" style="background-color: #fad419;"> 
                                                    <img src="@/assets/images/payment/delivery.png" style="width: 40px;height:100%; margin-right: 20px;">
                                                    <span>Таны захиалсан бараа захиалга баталгаажсанаас хойш 14-18 хоногт багтан ирэх бөгөөд захиалсан бүх бүтээгдэхүүн даатгалтай тул тээвэрлэлтийн явцад гарсан аливаа гэмтэлийг бид 100% хариуцах болно.</span>
                                                  </div>
                                               </div>
                                        </div>
                                        <b style="margin: 15px 10px 5px 10px; font-size: 1.2rem;display: block">Бонус</b>
                                        <div class="row"> 
                                            <div class="col-12">
                                                  <div class="deliver"> 
                                                    <img src="@/assets/images/payment/bonus.png" style="width: 40px;height:100%; margin-right: 20px;">
                                                    <span>Таны худалдан авалт амжилттай болсоноор танд худалдан авсан барааны үнийн дүнгийн 1% тай тэнцэх мөнгөн дүнтэй бонусыг буцаан олгох болно. Та энэхүү бонусыг дараагийн худалдан авалтандаа агшиглах боломжтой.</span>
                                                  </div>
                                               </div>
                                        </div>
                                    </div>
                                 </div>

                                <!-- <div class="col-md-12 p-1">
                                    <div class="card-flex p-5" v-bind:class="{'card-active': payment == 'qpay'}" @click="changePayment('qpay')">
                                        <img src="@/assets/images/logo/qpay.png" class="mr-3" :style="{'width': '50px', 'height': '50px'}"/>
                                        <span><strong>QPAY ЭСВЭЛ ДАНСАНД ШИЛЖҮҮЛЭХ</strong> <br> <span class="mt-1" style="line-height: 100%; display: block;">Интернет банкны QR код ашиглан төлбөр төлөх эсвэл төлбөрийг дансанд шилжүүлэх</span></span>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-12 p-1 mt-2">
                                    <div class="card-flex p-5" v-bind:class="{'card-active': payment == 'mongolchat'}" @click="changePayment('mongolchat')">
                                        <img src="@/assets/images/logo/mongolchat.png" class="mr-3" :style="{'width': '50px', 'height': '50px'}"/>
                                        <span><strong>Mongol Chat</strong> <br> <span class="mt-1" style="line-height: 100%; display: block;">Mongol Chat аппликэйшныг ашиглан төлбөр төлөх</span></span>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-12 p-1 mt-2">
                                    <div class="card-flex p-5" v-bind:class="{'card-active': payment == 'storepay'}" @click="changePayment('storepay')">
                                        <img src="@/assets/images/logo/storepay.png" class="mr-3" :style="{'width': '50px', 'height': '50px'}"/>
                                        <span><strong>STOREPAY</strong> <br> <span class="mt-1" style="line-height: 100%; display: block;">Та StorePay үйлчилгээг ашиглан хүүгүй, шимтгэлгүй хуваан төлөх боломжтой</span></span>
                                    </div>
                                </div>
                                <div class="col-md-12 p-1 mt-2">
                                    <div class="card-flex p-5" v-bind:class="{'card-active': payment == 'mcredit'}" @click="changePayment('mcredit')">
                                        <img src="@/assets/images/logo/mcredit.png" class="mr-3" :style="{'width': '50px', 'height': '50px'}"/>
                                        <span><strong>MCREDIT</strong> <br> <span class="mt-1" style="line-height: 100%; display: block;">Хүссэн бараагаа одоо аваад хүү, шимтгэлгүй 4 хуваан төлөх боломжтой</span></span>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="mb-8 cart-total col-md-4" align="center">
                            <div class="row card p-5 mb-3">
                                <div class="border-bottom border-color-1 mb-3" align="right">
                                    <h3 class="d-inline-block mb-0 pb-2 font-size-22">Бүтээгдэхүүн</h3>
                                </div>
                                <table class="table mb-3 mb-md-0">
                                    <tbody>
                                        <tr v-for="(item, index) in cart.product" :key="index" class="cart-subtotal">
                                            <th>{{item.name}}</th>
                                            <td data-title="Subtotal"><span class="amount">{{item.quantity}} X ₮{{Number(item.amount*item.quantity).toLocaleString()}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row card p-5">
                                <div class="col-md-14">
                                    <div class="border-bottom border-color-1 mb-3" align="right">
                                        <h3 class="d-inline-block  mb-0 pb-2 font-size-22">Захиалгын мэдээлэл</h3>
                                    </div>
                                    <table class="table mb-3 mb-md-0">
                                        <tbody>
                                            <tr class="cart-subtotal">
                                                <td class="subtotal-items"> Үнэ</td>
                                                <td data-title="Үнэ"><span class="amount">₮{{Number(cart.subtotal).toLocaleString()}}</span></td>
                                            </tr>
                                            <!-- <tr class="cart-subtotal" v-if="cart.useBonus>0" style="color:#0057AD;">
                                                <td class="subtotal-items"> Ашигласан бонус</td>
                                                <td data-title="Ашиглах бонус" >{{Number(cart.useBonus)}}</td>
                                            </tr> -->
                                            <tr class="cart-subtotal check" style="color:#0057AD;">
                                                <td class="subtotal-items"> <input type="checkbox" v-model="useBonus" >Ашиглах бонус</td>
                                                <td style="vertical-align: middle;" v-if="useBonus"> 
                                                    <div class="input-number2"> 
                                                        <a  href="javascript:;" class="counts2" @click="changeBonus(false)" >-</a>
                                                        <span style="margin-top: 2px;font-size: 14px;">₮</span>
                                                          <input type="number" v-model="cart.useBonus" :min="1" :max="this.cart.bonusLimit" @change="bonusChanged" class="product-count">
                                                        <a  href="javascript:;" class="counts2" @click="changeBonus(true)">+</a>
                                                   </div>
                                                </td>
                                                <td v-else> <span>₮ 0</span></td>
                                            </tr>
                                            <tr class="cart-subtotal" v-if="cart.sale>0">
                                                <td class="subtotal-items"> Хямдрал</td>
                                                <td data-title="Хямдрал"><span class="amount">₮{{Number(parseInt(cart.sale)).toLocaleString()}}</span></td>
                                            </tr>
                                            <tr class="cart-subtotal" v-if="coupon.amount>0" style="color:#0057AD;">
                                                <td class="subtotal-items"> Ваучер</td>
                                                <td data-title="Хөнгөлөлт"><span class="amount">₮{{Number(parseInt(coupon.amount)).toLocaleString()}}</span></td>
                                            </tr>
                                            <tr class="order-total" v-if="shipping.amount>0">
                                                <td class="subtotal-items"> Хүргэлт</td>
                                                <td>₮{{Number(shipping.amount).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="cart.assemble>0">
                                                <td class="subtotal-items"> Угсралт</td>
                                                <td>₮{{Number(cart.assemble).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total" v-if="cart.mow>0">
                                                <td class="subtotal-items"> Тогтоолт</td>
                                                <td>₮{{Number(cart.mow).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total font-size-10" v-if="cart.chinaDeliver>0">
                                                <td class="subtotal-items"><span>Овор, жингийн нэмэгдэл</span></td>
                                                <td style="vertical-align: middle;">₮{{(cart.chinaDeliver).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total font-size-10" v-if="lend.fee>0">
                                                <td class="subtotal-items"><span>{{lend.type}}</span></td>
                                                <td style="vertical-align: middle;">₮{{(lend.fee).toLocaleString()}}</td>
                                            </tr>
                                            <tr class="order-total">
                                                <td class="subtotal-items"> Үйлчилгээний хөлс</td>
                                                <td>₮{{Number(cart.Fee).toLocaleString()}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div style="border: solid 1px;"></div>
                                    <table class="table mb-3 mb-md-0">
                                        <tbody>
                                            <tr class="order-total" v-if="cart.NOAT>0">
                                                <td class="subtotal-items"> НӨАТ</td> 
                                                 <td>₮{{Number((cart.sum-cart.NOAT+lend.fee-cart.useBonus)*0.1).toLocaleString()}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div style="display: flex;justify-content: space-between;align-items: center ;padding:0 12px;margin-top: 10px;"> 
                                        <b class="total-amount">Нийт дүн</b>
                                       <span class="price font-size-18 font-weight-bold" v-if="NOAT">{{(((cart.sum-cart.NOAT+lend.fee-cart.useBonus)*0.1)+(cart.sum-cart.NOAT+lend.fee-cart.useBonus)).toLocaleString()}}</span>
                                       <span class="price font-size-18 font-weight-bold" v-else>{{((cart.sum-cart.NOAT+lend.fee-cart.useBonus)).toLocaleString()}}</span>
                                       <!-- <span class="price font-size-18 font-weight-bold">{{(totalPrice).toLocaleString()}}</span> -->
                                     </div>
                                </div>
                            </div>
                            <div class="row pl-1 pr-1">
                                <div class="col-md-12" align="center">
                                    <button type="button" @click="submitForm" class="btn btn-primary-dark-w mt-3" style="width: 100%; border-radius: 12px;">Төлбөр</button>
                                    <button type="button" @click="backRoute" class="btn btn-outline-primary mt-1" style="width: 100%; border-radius: 12px;">Буцах</button>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </main>
        <Brands />
    </div>
</template>
<script>
import Brands from "@/components/brands";
const api = require("@what3words/api");
api.setOptions({ key: "E5XS8ZV3" });
export default {
    components: {
        Brands
    },
    data() {
        return {
            ordernumber:'',
            radio:'1',
            fullscreenLoading: false,
            checked:true,
            deliver:false,
            assemble:false,
            NOAT:false,
            useBonus:false,
            Fee:60000,
            compRegNOAT:'',
            mow:false,
            step:2,
            cart: {
                product: [],
                real: [],
                subtotal: 0,
                sale: 0,
                bonus: 0,
                useBonus: 0,
                bonusLimit: 0,
                assemble:0,
                chinaDeliver:0,
                Fee:0,
                mow:0,
                NOAT:0,
                sum:0
            },
            shipping: {
                amount: 0,
                warehouse:0,
                district:'',
                khoroo:0,
                more:'',
                user:{
                    bonus:0
                }
            },
            range: {
                district: [],
            },
            coupon: {
                code: null,
                active: false,
                amount: 0
            },
            payment: 'qpay',
            lend:{
                type:'',
                fee:0
            }
        }
    },
    mounted() {
        this.$emit('getJquery');
        this.ordernumber=this.$route.params.id;
        this.shipping.user.bonus = localStorage.getItem('bonus');
        this.getOrder();
    },
    computed:{
        filteredProducts(){
            let products=[];
            if(this.cart.product.length>0){
                this.cart.product.forEach(el=>{
                    if(el.checked==true && el.show_product!=0){
                        products.push(el);
                    }
                })
            }
            return products;
        }
    },
    watch:{
        'useBonus':function(val){
         if(val){
            this.cart.useBonus=this.cart.bonusLimit;
            }else{
            this.cart.useBonus=0;
         }
         }
    },
    methods: {
        calcSum(){
            this.cart.sum=this.cart.sum
        },
        bonusChanged(){
           if(this.cart.useBonus<1){
            this.cart.useBonus=0;
            this.cart.sum=this.cart.sum-this.cart.useBonus;
            localStorage.bonus = this.cart.useBonus;
           }else if(this.cart.useBonus>this.cart.bonusLimit){
            this.cart.useBonus=this.cart.bonusLimit;
            this.cart.sum=this.cart.sum-this.cart.useBonus;
            localStorage.bonus = this.cart.useBonus;
           }
        },
        checkBonus() {
            const user = JSON.parse(localStorage.getItem('user'));
            if(user) {
                return `${Number(user.bonus).toLocaleString()}`
            } else {
                return '';
            }
        },
        backRoute() {
            this.$router.push('/shipping');
        },
        changeBonus(val) {
            if(val){
                if(this.cart.useBonus<this.cart.bonusLimit){
                    this.cart.useBonus++;
                }
            }else{
                if(this.cart.useBonus>1){
                    this.cart.useBonus--;
                }
            }
        },
        calculateBonusLimit() {
            var am =parseInt(this.cart.sum);
            var limit = parseInt(am / 2);
            if(limit > this.shipping.user.bonus) {
                this.cart.bonusLimit = this.shipping.user.bonus;
            } else {
                this.cart.bonusLimit = limit;
            }
            localStorage.bonusLimit = this.cart.bonusLimit;
            var b = localStorage.getItem('bonus');
            if(b != null) {
                this.cart.useBonus = b;
            } else {
                this.cart.useBonus = this.cart.bonusLimit;
                localStorage.bonus = this.cart.useBonus;
            }
        },
        changePayment(pay) {
            if(pay=='storepay'){
                this.payment=pay;
                this.lend.type='Storepay';
                this.lend.fee=Math.ceil(this.cart.sum*0.099/100)*100;
            }else if(pay=='mcredit'){
                this.payment=pay;
                this.lend.type='Mcredit';
                this.lend.fee=Math.ceil(this.cart.sum*0.066/100)*100;
            }else if(pay=='KhanLending'){
                this.payment=pay;
                this.lend.type='Зээлийн шимтгэл';
                this.lend.fee=Math.ceil(this.cart.sum*0.011/100)*100;
            }else if(pay=='pocket'){
                this.payment=pay;
                this.lend.type='Pocket';
                this.lend.fee=Math.ceil(this.cart.sum*0.066/100)*100;
            } else{
                this.payment=pay;
                this.lend.type='';
                this.lend.fee=0; 
            }
        },
        RemoveCoupon() {
            localStorage.removeItem('coupon');
            this.coupon.code = null;
            this.coupon.amount = 0;
            this.coupon.active = false;
        },
        useCoupon() {
            var rts = this;
            const token = localStorage.getItem('token');
            rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/product/use-coupon',
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                data: {
                    coupon: this.coupon.code
                }
            }).then(data => {
                if (data.data.result == 'failed') {
                    rts.$notify({
                        title: 'Амжилтгүй',
                        message: `Купон код буруу эсвэл ашиглагдсан байна`,
                        type: 'error'
                    });
                } else {
                    var am = this.cart.subtotal - this.cart.sale;
                    if(parseInt(am/2)<data.data.promo[0].amount){
                        rts.coupon.amount=parseInt(am/2);
                        localStorage.coupon = JSON.stringify({code: rts.coupon.code, amount:parseInt(am/2)});
                    }else{
                        rts.coupon.amount = data.data.promo[0].amount;
                        localStorage.coupon = JSON.stringify({code: rts.coupon.code, amount: data.data.promo[0].amount});
                    }
                    rts.coupon.active = true;
                    rts.$notify({
                        title: 'Амжилттай',
                        dangerouslyUseHTMLString: true,
                        message: `Үнийн дүнгээс <strong>${rts.coupon.amount}₮</strong> хасагдлаа`,
                        type: 'success'
                    });
                }
            });
        },
        calculateShipping() {
           if(this.cart.subtotal - this.cart.sale - this.coupon.amount > 200000) {
                this.shipping.amount = 5000;
            } else {
                this.shipping.amount = parseInt(localStorage.getItem('shipping'));
                this.range.district.forEach(element => {
                    if(element.district == this.shipping.user.district) {
                        var cheap = []; var exp = [];
                        if (element.cheap_khoroo != null) {
                            cheap = element.cheap_khoroo.split(',');
                        }
                        if (element.middle_khoroo != null) {
                            exp = element.middle_khoroo.split(',');
                        }
                        if(cheap.includes(String(this.shipping.user.khoroo))) {
                            this.shipping.amount = 3000;
                        } else if(exp.includes(String(this.shipping.user.khoroo))) {
                            this.shipping.amount = 8000;
                        } else {
                            this.shipping.amount = 5000;
                        }
                    }
                });
            }
            localStorage.shipping = this.shipping.amount;
        },
        calculate() {
            var subtotal = 0; var sale = 0; var bonus = 0;
            this.cart.product.forEach(element => {
                subtotal = subtotal + (element.amount * element.quantity);
            });
            this.cart.subtotal = subtotal;
        },
        submitForm() {
            if(this.payment == '') {
                this.$notify({
                    title: 'Амжилтгүй',
                    message: `Төлбөрийн нөхцөлөө сонгоно уу`,
                    type: 'error'
                });
            } else {
                this.fullscreenLoading = true;
                const token = localStorage.getItem('token');
                var rts = this;
                let toNOAT=0;
                let toSUM=this.cart.sum;
                if(rts.NOAT){
                   toNOAT=Number((this.cart.sum-this.cart.NOAT+this.lend.fee-this.cart.useBonus)*0.1);
                   toSUM=Number(((this.cart.sum-this.cart.NOAT+this.lend.fee-this.cart.useBonus)*0.1)+(this.cart.sum-this.cart.NOAT));
                }
                rts.$axios({
                    method: 'POST',
                    url: rts.$appUrl + '/api/purchase/submit-order',
                    headers: {
                        "Authorization": `Bearer ${token}`
                    },
                    data: {
                         ordernumber:this.ordernumber,
                         payment:this.payment,
                         lend:this.lend,
                         usedBonus:parseInt(this.cart.useBonus),
                         noat:toNOAT,
                         sum:parseInt(toSUM)
                    }
                }).then(data => {
                    rts.fullscreenLoading = false;
                    if(data.data.result == 'failed') {
                        rts.$notify({
                            title: 'Амжилтгүй',
                            message: data.data.data,
                            type: 'error'
                        });
                    } else {
                        rts.$emit('calcCart');
                        rts.$router.push({name: 'show-order', params: {invoiceId: data.data.invoiceId}});
                    }
                }).catch(err => {
                    rts.fullscreenLoading = false;
                    console.log(err);
                });
            }
        },
        getOrder() {
            this.fullscreenLoading = true;
            var rts = this;
            rts.$axios({
                method: 'POST',
                url: rts.$appUrl + '/api/product/get-incomplete-order',
                headers: {},
                data: {
                    ordernumber:this.ordernumber
                }
            }).then(function(data) {
                rts.fullscreenLoading = false;
                rts.cart.real = data.data.products;
                rts.cart.product = data.data.products;
                rts.cart.bonus=data.data.order.add_bonus;
                rts.cart.sale=data.data.order.discount;
                rts.cart.chinaDeliver=data.data.order.chinaDeliver;
                rts.coupon.amount=data.data.order.coupon;
                rts.cart.Fee=data.data.order.fee;
                rts.shipping.amount=data.data.order.tax;
                rts.cart.assemble=data.data.order.assemble;
                rts.cart.mow=data.data.order.mow;
                rts.cart.NOAT=data.data.order.NOAT;
                if(data.data.order.NOAT!=0){
                    rts.NOAT=true;
                }
                rts.cart.sum=data.data.order.total_amount;
                rts.shipping.district=data.data.order.district;
                rts.shipping.khoroo=data.data.order.khoroo;
                rts.shipping.more=data.data.order.more_address;
                rts.shipping.warehouse=data.data.order.warehouse;
                rts.calculate();
                rts.calculateBonusLimit();
                rts.cart.useBonus=0;
            }).catch(error => {
                rts.fullscreenLoading = false;
                console.log(error);
            })
        }
    }
}
</script>